import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';
import { useNavigate } from '@tanstack/react-router';

export type CreateSquareRequest = {
  tenant_id: string;
  contest_name_en: string;
  contest_name_fr?: string;
  contest_subtext_en?: string;
  contest_subtext_fr?: string;
  lobby_tags?: string[] | null;
  status?: string;
  entry_fee?: number;
  max_squares_per_user?: number;
  start_time_utc: string;
  selection_editable_until_utc?: string;
  row_team_id?: string;
  col_team_id?: string;
  row_team_display_name?: string;
  col_team_display_name?: string;
  row_team_bg_color?: string;
  col_team_bg_color?: string;
  row_team_icon_url?: string;
  col_team_icon_url?: string;
  sport: string;
  fixture_id?: string;
  scheduled_game_start_utc?: string;
  feed_provider?: string;
  grid_rows?: number;
  grid_cols?: number;
  periods?: any[];
  winner_rule?: string;
  winner_rule_config?: any;
  payout_distribution_method?: string;
  total_prize_amount?: number;
  [key: string]: any;
};

type CreateSquareResponse = {
  squares_contest: {
    squares_contest_id: string;
    [key: string]: any;
  };
  message: string;
};

export const createSquare = (data: CreateSquareRequest): Promise<CreateSquareResponse> =>
  apiClient.post('/api/admin/squares' as any, data) as Promise<CreateSquareResponse>;

export const useCreateSquareMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<CreateSquareResponse, Error, CreateSquareRequest>({
    mutationFn: createSquare,
    onSuccess: response => {
      queryClient.invalidateQueries({ queryKey: queryKeys.squares?.all || ['squares'] });
      toast.success('Squares contest created successfully');
      navigate({
        to: '/dashboard/squares/$id',
        params: { id: response.squares_contest.squares_contest_id },
        search: { tenant_id: undefined, tab: undefined },
      });
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to create squares contest');
    },
  });
};
